import { Box } from "@mui/material";
import SEO from "../../components/Common/SEO";
import OurProcess from "../About/OurProcess";
import CTASection from "../Home/CTABanner";
import FAQSection from "../Home/FAQSection";
import HowItWorks from "../Home/HowItWork";
import StatsSection from "../Home/StatsSection";
import WhyChooseUs from "../Home/WhyChooseUs";
import BeyondLaundryServices from "./BeyondLaundryServices";
import PremiumGarmentCare from "./PremiumGarmentCare";
import ServicesHero from "./ServicesHero";
import PremiumServiceSection from "../PremiumServiceSection/PremiumServiceSection";
import shoeHero from "../../assets/images/New/shoeHero.png";
import shoeBefore from "../../assets/images/New/shoeBefore.png";
import shoeAfter from "../../assets/images/New/shoeAfter.png";
import dryCleaningAfter from "../../assets/images/New/dryCleaningAfter.png";
import dryCleaningBefore from "../../assets/images/New/dryCleaningBefore.png";
import dryCleaningHero from "../../assets/images/New/dryCleaningHero.png";
import printingHero from "../../assets/images/New/printingHero.png";
import printingBefore from "../../assets/images/New/printingBefore.png";
import printingAfter from "../../assets/images/New/printingAfter.png";
import alterationHero from "../../assets/images/New/alterationHero.png";
import alterationBefore from "../../assets/images/New/alterationBefore.png";
import alterationAfter from "../../assets/images/New/alterationAfter.png";

import weddingHero from "../../assets/images/New/weddingHero.png";
import weddingBefore from "../../assets/images/New/weddingBefore.png";
import weddingAfter from "../../assets/images/New/weddingAfter.png";

import rugHero from "../../assets/images/New/rugHero.png";
import rugBefore from "../../assets/images/New/rugBefore.png";
import rugAfter from "../../assets/images/New/rugAfter.png";

import handbagHero from "../../assets/images/New/handbagHero.png";
import handbagBefore from "../../assets/images/New/handbagBefore.png";
import handbagAfter from "../../assets/images/New/handbagAfter.png";

import comforterHero from "../../assets/images/New/comforterHero.png";
import comforterBefore from "../../assets/images/New/comforterBefore.png";
import comforterAfter from "../../assets/images/New/comforterAfter.png";

import cushionHero from "../../assets/images/New/cushionHero.png";
import cushionBefore from "../../assets/images/New/cushionBefore.png";
import cushionAfter from "../../assets/images/New/cushionAfter.png";

import steamHero from "../../assets/images/New/steamHero.png";
import steamBefore from "../../assets/images/New/steamBefore.png";
import steamAfter from "../../assets/images/New/steamAfter.png";


const Services = () => {
  return (
    <>
      <SEO page="services" />
      <ServicesHero />
       <PremiumServiceSection
              title="Premium Dry Cleaning"
              subtitle="Professional Garment Care"
              description="Expert dry cleaning for suits, shirts, dresses, blazers, winter coats and delicate garments. Our advanced cleaning process removes stains, protects fabrics and restores a fresh, professional appearance."
              image={dryCleaningHero}
              beforeImage={dryCleaningBefore}
              afterImage={dryCleaningAfter}
              imagePosition="right"
              features={[
                "Suit Cleaning",
                "Shirt Cleaning",
                "Blazer Care",
                "Winter Coat Cleaning",
                "Delicate Fabric Care",
              ]}
            />
            <PremiumServiceSection
              title="Custom Printing Services"
              subtitle="Bring Your Ideas To Life"
              description="High-quality custom printing for t-shirts, hoodies, uniforms, promotional products and corporate branding."
              image={printingHero}
              beforeImage={printingBefore}
              afterImage={printingAfter}
              imagePosition="left"
              features={[
                "T-Shirt Printing",
                "Uniform Printing",
                "Corporate Branding",
                "Event Merchandise",
                "Promotional Printing",
              ]}
            />
            <PremiumServiceSection
              title="Premium Shoe Cleaning & Repair"
              subtitle="Restore Your Favorite Footwear"
              description="Professional sneaker restoration, deep cleaning and luxury shoe care for everyday footwear and designer brands."
              image={shoeHero}
              beforeImage={shoeBefore}
              afterImage={shoeAfter}
              imagePosition="right"
              features={[
                "Shoe Cleaning",
                "Sneaker Restoration",
                "Deep Cleaning",
                "Luxury Shoe Care",
                "Shoe Repair",
              ]}
            />
            <PremiumServiceSection
              title="Expert Alterations & Repairs"
              subtitle="Perfect Fit Every Time"
              description="Professional alterations including hemming, zipper replacement, sleeve adjustments, dress fitting, trouser shortening and garment repairs."
              image={alterationHero}
              beforeImage={alterationBefore}
              afterImage={alterationAfter}
              imagePosition="left"
              features={[
                "Pant Hemming",
                "Same-Day Alterations",
                "Zipper Replacement",
                "Button Repairs",
                "Dress Fitting",
              ]}
            />
      
            <PremiumServiceSection
              title="Wedding Dress Cleaning & Preservation"
              subtitle="Protect Your Special Memories"
              description="Specialized bridal gown cleaning, preservation and alteration services designed to maintain the beauty of your wedding dress for years to come."
              image={weddingHero}
              beforeImage={weddingBefore}
              afterImage={weddingAfter}
              imagePosition="right"
              features={[
                "Wedding Dress Cleaning",
                "Bridal Alterations",
                "Dress Preservation",
                "Stain Removal",
                "Luxury Fabric Care",
              ]}
            />
            
            <PremiumServiceSection
              title="Professional Rug Cleaning"
              subtitle="Deep Cleaning For Every Rug"
              description="Restore the beauty of your area rugs with deep cleaning, stain removal and odor treatment services."
              image={rugHero}
              beforeImage={rugBefore}
              afterImage={rugAfter}
              imagePosition="left"
              features={[
                "Area Rug Cleaning",
                "Stain Removal",
                "Odor Removal",
                "Deep Cleaning",
                "Rug Restoration",
              ]}
            />
            <PremiumServiceSection
              title="Luxury Handbag Cleaning & Repair"
              subtitle="Designer Bag Restoration"
              description="Professional cleaning and restoration for luxury handbags, purses and designer accessories."
              image={handbagHero}
              beforeImage={handbagBefore}
              afterImage={handbagAfter}
              imagePosition="right"
              features={[
                "Handbag Cleaning",
                "Designer Bag Care",
                "Leather Treatment",
                "Color Restoration",
                "Luxury Accessories",
              ]}
            />
            <PremiumServiceSection
              title="Comforter & Blanket Cleaning"
              subtitle="Freshness For Your Home"
              description="Professional comforter, blanket and bedding cleaning services for a cleaner and healthier home."
              image={comforterHero}
              beforeImage={comforterBefore}
              afterImage={comforterAfter}
              imagePosition="left"
              features={[
                "Comforter Cleaning",
                "Blanket Cleaning",
                "Bedding Care",
                "Deep Sanitization",
                "Fresh Finish",
              ]}
            />
            <PremiumServiceSection
              title="Professional Cushion Cleaning"
              subtitle="Refresh Your Living Space"
              description="Deep cleaning solutions for sofa cushions, decorative cushions and upholstery fabrics."
              image={cushionHero}
              beforeImage={cushionBefore}
              afterImage={cushionAfter}
              imagePosition="right"
              features={[
                "Cushion Cleaning",
                "Fabric Care",
                "Stain Removal",
                "Odor Removal",
                "Upholstery Refresh",
              ]}
            />
            <PremiumServiceSection
              title="Professional Steam Pressing"
              subtitle="Wrinkle-Free Perfection"
              description="Crisp and professional steam pressing for shirts, suits, dresses and delicate garments."
              image={steamHero}
              beforeImage={steamBefore}
              afterImage={steamAfter}
              imagePosition="left"
              features={[
                "Steam Pressing",
                "Shirt Pressing",
                "Suit Pressing",
                "Dress Pressing",
                "Professional Finish",
              ]}
            />
      <PremiumGarmentCare />
      <BeyondLaundryServices />
      <OurProcess />
      <HowItWorks />
      <StatsSection />
      <WhyChooseUs />
      <FAQSection />
      <CTASection />
      <Box sx={{ display: "none" }}>
        Dry Cleaning Ajax Laundry Service Ajax Wedding Dress Cleaning Ajax
        Alterations Ajax Rug Cleaning Ajax Shoe Repair Ajax Handbag Cleaning
        Ajax Dry Cleaners Pickering Dry Cleaners Whitby
      </Box>
    </>
  );
};

export default Services;
